export const extractListObjectError = (error: any): string | null => {
  for (const value of Object.values(error)) {
    if (typeof value === "string") return value;
    else if (Array.isArray(value) && value?.length > 0) return value?.[0];
  }
  return null;
};
